import { combineReducers } from 'redux';
import HoneybeeReducer from 'email_automations/ducks/honeybee';
import BumblebeeReducer from 'email_automations/ducks/bumblebee';
import CommonReducer from 'email_automations/ducks/common';

const RootReducer = combineReducers({
  honeybee: HoneybeeReducer,
  bumblebee: BumblebeeReducer,
  common: CommonReducer
});

export default RootReducer;



// WEBPACK FOOTER //
// ./email_automations/ducks/index.js